import { Box, Checkbox, Grid, IconButton, Typography, useTheme } from "@mui/material"
import { Format } from "../../../../../../utils"
import { useState } from "react"
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md"
import moment from "moment"
import { LineComponent } from "../../../../../../components/line"

interface Props {
    checked: boolean,
    onChange: (newValue: boolean) => void,
    parcel: number,
    totalParcels: number,
    value: number,
    dueDate: string,
    originalValue: number,
    valueOfTheFine: number,
    daysLate: number,
    pending?: boolean,
    disabled?: boolean
}

export const Parcels = ({
    checked,
    onChange,
    parcel,
    totalParcels,
    value,
    daysLate,
    dueDate,
    originalValue,
    valueOfTheFine,
    pending,
    disabled
}: Props) => {
    const { palette } = useTheme()
    const [expanded, setExpanded] = useState(false)

    const handleChange = (value: boolean) => {
        if (!disabled) onChange(value)
    }

    return (
        <Grid
            sx={{
                width: "calc(100% + 5rem)",
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                padding: ".5rem 2.5rem",
                ... (checked && expanded && {
                    backgroundColor: "rgba(23, 139, 241, 0.15)",
                }),
                ...(disabled && {
                    opacity: 0.5
                })
            }}
            onClick={() => handleChange(!checked)}
        >
            <Checkbox checked={checked} onChange={(e) => handleChange(e.target.checked)} size="large" sx={{ ml: "-1.1rem" }} />
            <Grid
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "10px",
                    border: `1px solid ${checked ? palette.primary.main : "transparent"}`
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "10px",
                        minHeight: "55px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: ".5rem 1.5rem",
                        paddingLeft: ".5rem",
                        boxSizing: "border-box",
                        border: "none",
                    }}
                    component={"button"}
                >
                    <Grid display={"flex"} direction={"column"} justifyContent={"center"} alignItems={"flex-start"}>
                        <Typography variant="body1" fontWeight={600}>{parcel} de {totalParcels}</Typography>
                        <Typography fontSize={"1.2rem"} sx={{ opacity: expanded ? 0 : .5 }} textAlign={"left"}>Venc.: {moment(dueDate).format("DD/MM/YY")}<br />({moment(dueDate).format("dddd")})<strong>{moment(dueDate).isSame(moment(), "day") ? " Hoje" : ""}</strong></Typography>
                    </Grid>
                    <Grid display={"flex"} direction={"row"} alignItems={"center"}>
                        <Grid display={"flex"} direction={"column"} justifyContent={"center"} alignItems={"flex-end"}>
                            <Typography fontWeight={700} fontSize={"1.2rem"} textOverflow={"ellipsis"} whiteSpace={"nowrap"} overflow={"hidden"} width={"100%"} textAlign={"right"}>Valor{pending ? "  atualizado" : ""}</Typography>
                            <Typography variant="body1" fontWeight={600} color={pending ? "error" : "primary"}>{Format.currency(value)}</Typography>
                        </Grid>
                        <IconButton onClick={(e) => {
                            e.stopPropagation()
                            setExpanded(!expanded)
                        }}>
                            {expanded ? <MdKeyboardArrowUp size={24} /> : <MdKeyboardArrowDown size={24} />}
                        </IconButton>
                    </Grid>
                </Box>

                {expanded &&
                    <Box
                        sx={{
                            mt: -1,
                            width: "100%",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            display: "flex",
                            flexDirection: "column",
                            pb: "1rem",
                            borderRadius: "10px",

                        }}
                    >
                        <Grid display={"flex"} direction={"row"} justifyContent={"space-between"} alignItems={"center"} padding={"0px 1rem"} mt={"3rem"}>
                            <Typography fontWeight={400} fontSize={"1.2rem"}>Vencimento</Typography>
                            <Typography fontWeight={400} fontSize={"1.2rem"}>{moment(dueDate).format("DD/MM/YYYY[ (]dddd[)]")}</Typography>
                        </Grid>

                        <LineComponent expansive={false} color="rgba(0, 0, 0, 0.5)" height="0.5px" margin="1rem 0rem" />

                        <Grid display={"flex"} direction={"row"} justifyContent={"space-between"} alignItems={"center"} padding={"0px 1rem"}>
                            <Typography fontWeight={400} fontSize={"1.2rem"}>Valor original:</Typography>
                            <Typography fontWeight={400} fontSize={"1.2rem"}>{Format.currency(originalValue)}</Typography>
                        </Grid>


                        {pending &&
                            <>
                                <LineComponent expansive={false} color="rgba(0, 0, 0, 0.5)" height="0.5px" margin="1rem 0rem" />

                                <Grid display={"flex"} direction={"row"} justifyContent={"space-between"} alignItems={"center"} padding={"0px 1rem"}>
                                    <Typography fontWeight={400} fontSize={"1.2rem"}>
                                        + Multa (cláusula penal)
                                        <br />
                                        + Juros de mora
                                        <br />
                                        + Honorários advocatícios:
                                    </Typography>
                                    <Typography fontWeight={400} fontSize={"1.2rem"}>{Format.currency(valueOfTheFine)}</Typography>
                                </Grid>

                                <LineComponent expansive={false} color="rgba(0, 0, 0, 0.5)" height="0.5px" margin="1rem 0rem" />

                                <Grid display={"flex"} direction={"row"} justifyContent={"space-between"} alignItems={"center"} padding={"0px 1rem"}>
                                    <Typography fontWeight={400} fontSize={"1.2rem"}>Dias em atraso:</Typography>
                                    <Typography fontWeight={400} fontSize={"1.2rem"}>{daysLate}</Typography>
                                </Grid>
                            </>
                        }

                    </Box>
                }

            </Grid>
        </Grid>
    )

}